import { Gauge } from "@ant-design/charts";
import React from "react";

function ProgressChart({ totalPercentage, height, width }) {
  console.log("🚀 ~ ProgressChart ~ totalPercentage:", isNaN(totalPercentage));
  const config = {
    range: {
      ticks: [0, totalPercentage / 100, 1],
      color: "l(0) 0:#FFA380 0.5:#FFA458 1:#E3302E",
    },
    startAngle: Math.PI,
    endAngle: 2 * Math.PI,
    indicator: null,
    statistic: {
      title: {
        style: {
          fontSize: "30px",
          color: "#000000",
          fontWeight: "bold",
        },
        formatter: () => (width ? null : `${totalPercentage}% Completed`),
      },
    },
  };
  return (
    <div
      className="rounded-3xl p-5"
      // className="shadow-[0px_4px_18px_0px_#4B465C1A] rounded-3xl p-5"
    >
      <Gauge height={height} width={width} {...config} />
      {width && (
        <div className="text-center -mt-14 font-semibold">
          <h1 className="text-3xl">
            {isNaN(totalPercentage) ? 0 : totalPercentage}%
          </h1>
          <h1>Completed</h1>
        </div>
      )}
    </div>
  );
}

export default ProgressChart;
